import React from 'react';

const RIGHTS = [
  ['Electronic Frontier Foundation', 'https://www.eff.org/'],
  ['Reclaim The Net', 'https://reclaimthenet.org/'],
  ['Aaron Swartz Day', 'https://www.aaronswartzday.org/'],
  ['Institute for Justice', 'https://ij.org/'],
  ['European Digital Rights (EDRi)', 'https://www.edri.org/'],
  ['Open Rights Group', 'https://www.openrightsgroup.org/'],
];

const OSS = [
  ['Debian', 'https://www.debian.org/'],
  ['Linux Foundation', 'https://www.linuxfoundation.org/'],
  ['The Block Foundation', 'https://theblockfound.com/'],
  ['Zorin', 'https://www.zorin.com/'],
  ['Garuda Linux', 'https://garudalinux.org/'],
  ['DistroWatch', 'https://distrowatch.com/'],
];

const CauseCol = ({ kj, title, links }) => (
  <div className="cvfoot__col">
    <div className="cvfoot__h">
      <span className="kj">{kj}</span>
      {title}
    </div>
    {links.map(([label, href]) => (
      <a key={href} href={href} target="_blank" rel="noopener noreferrer">
        {label} ↗
      </a>
    ))}
  </div>
);

const CvFooter = () => (
  <footer className="cvfoot">
    <div className="cvfoot__in">
      <CauseCol kj="権" title="Digital Rights Advocacy" links={RIGHTS} />
      <CauseCol kj="開" title="Open Source" links={OSS} />
    </div>
    <div className="cvfoot__base">© 2026 CRYPTOVERSE-AI · WE SUPPORT THE OPEN WEB</div>
  </footer>
);

export default CvFooter;
